<template>
  <label class="icon-box" @click="handleClick">
    <auth-img class="icon-img" :src="img" alt="" />
    <div class="icon-label">预病历</div>
  </label>
  <PreMedicalRecordModal ref="PreMedicalRecordModalRef" />
</template>

<script setup>
import { computed, ref, defineProps } from 'vue'
import img from '@/assets/img/chat/diagnosis.png'
import PreMedicalRecordModal from '@/components/PreMedicalRecordModal'

const props = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {},
    required: true
  }
})

const PreMedicalRecordModalRef = ref(null)
const handleClick = () => {
  const { doctorInfo, patientInfo } = props.workOrderGroupInfo
  PreMedicalRecordModalRef.value.modalInit({
    patientId: patientInfo.businessId,
    ucPatientId: patientInfo.ucUserId,
    ucDoctorId: doctorInfo.ucUserId,
    doctorId: doctorInfo.businessId
  })
}
</script>

<style lang="scss" scoped>
@import '../../index.scss';
.icon-box {
  .icon-label.active {
    color: #1890ff;
  }
}
</style>
